import React from 'react'
import Calendar from '@toast-ui/react-calendar'
import Modal from '../../../Components/Modal/Modal'
import '../../Availability/tui-calendar.css'
import 'tui-date-picker/dist/tui-date-picker.css'
import 'tui-time-picker/dist/tui-time-picker.css'

import {
  WEEKLY_CUSTOM_THEME,
  calendarTemplate,
  buildCalenderControlPanel,
  buildBookingSchedule,
} from '../../../Helper/CalendarHelper'

const Moment = require('moment')
const MomentRange = require('moment-range')
const moment = MomentRange.extendMoment(Moment)

const initialState = {
  isPopUp: false,
  view: 'month',
  today: moment(new Date()).format('MMM YYYY'),
  visibleWeeksCount: 0,
  toggleWeekend: 'Hide Weekend',
}

class AllocationCalendar extends React.Component {
  constructor(props) {
    super(props)

    this.state = { ...initialState }
  }

  calendarRef = React.createRef()

  handleClickNextButton = () => {
    const calendarInstance = this.calendarRef.current.getInstance()
    calendarInstance.next()
    this.setState({
      today: moment(calendarInstance._renderDate._date).format('MMM YYYY'),
    })
  }

  handleClickPrevButton = () => {
    const calendarInstance = this.calendarRef.current.getInstance()
    calendarInstance.prev()
    this.setState({
      today: moment(calendarInstance._renderDate._date).format('MMM YYYY'),
    })
  }

  handleRenderDate = () => {
    const calendarInstance = this.calendarRef.current.getInstance()
    this.setState({
      today: moment(calendarInstance._renderDate._date).format('MMM YYYY'),
    })
  }

  handleClickTodayButton = () => {
    const calendarInstance = this.calendarRef.current.getInstance()
    calendarInstance.today()
    this.setState({
      today: moment(calendarInstance._renderDate._date).format('MMM YYYY'),
    })
  }

  saveDate = async () => {}

  togglePopup = (value) => {
    this.setState({ isPopUp: value })
  }

  handleClose = () => {
    this.setState({ ...initialState })
  }

  getScheduleBookingInfo = (id) => {
    return ''
  }

  onViewChange = (event) => {
    if (event.target.value === '2 weeks') {
      this.setState({ visibleWeeksCount: 2 })
      this.setState({ view: 'month' })
    } else if (event.target.value === 'month') {
      this.setState({ visibleWeeksCount: 0 })
      this.setState({ view: event.target.value })
    } else {
      this.setState({ view: event.target.value })
    }
  }

  onHideWeekend = () => {
    this.setState({ isWorkWeek: !this.state.isWorkWeek })
    let value =
      this.state.toggleWeekend === 'Hide Weekend'
        ? 'Show weekend'
        : 'Hide Weekend'
    this.setState({ toggleWeekend: value })
  }

  handleClickTodayButton = () => {
    const calendarInstance = this.calendarRef.current.getInstance()
    calendarInstance.today()
    this.setState({
      today: moment(calendarInstance._renderDate._date).format('DD-MM-YYYY'),
    })
  }

  render() {
    var { isPopUp, selected_date, today } = this.state
    var bookingsSchedule = buildBookingSchedule(this.props.job)

    return (
      <div>
        {isPopUp && (
          <div>
            <Modal
              show={true}
              className='book-teacher-modal'
              onClose={this.handleClose}
              header={
                this.state.teacher_name ? (
                  <>Book {this.state.teacher_name}</>
                ) : (
                  <>
                    Book a Teacher for
                    <br />
                    {selected_date
                      ? moment(selected_date).format('DD-MM-YYYY')
                      : ''}
                  </>
                )
              }
            ></Modal>
          </div>
        )}

        {buildCalenderControlPanel(
          this.onViewChange,
          this.onHideWeekend,
          this.handleClickTodayButton,
          this.handleClickPrevButton,
          this.handleClickNextButton,
          this.state.toggleWeekend,
          today
        )}

        <Calendar
          taskView={false}
          today={true}
          view={this.state.view}
          alldayView={false}
          theme={WEEKLY_CUSTOM_THEME}
          month={{
            workweek: this.state.isWorkWeek,
            startDayOfWeek: 0,
            visibleWeeksCount: this.state.visibleWeeksCount,
          }}
          week={{
            workweek: this.state.isWorkWeek,
          }}
          ref={this.calendarRef}
          useCreationPopup={false}
          schedules={bookingsSchedule}
          scheduleView
          onLoad={this.handleRenderDate}
          useDetailPopup={false}
          onClickSchedule={(e) => {
            const msg = this.getScheduleBookingInfo(e.schedule.id)
          }}
          onBeforeUpdateSchedule={(e) => {
            var schedule = e.schedule
            var changes = e.changes
            this.updateSchedule(schedule.id, schedule.calendarId, changes)
          }}
          template={calendarTemplate}
        />
      </div>
    )
  }
}

export default AllocationCalendar
